<template>
  <div>
    <div class="recent-actions d-flex py-2 me-2">
      <div :style="cssBackgroundColorForOverlay" class="overlay" />
      <recent-action v-for="(recentAction, index) in recentActions" :key="`${recentAction.name}-${index}`"
                     :created-at="recentAction.createdAt">
        {{ getActionText(recentAction) }}
      </recent-action>
    </div>
  </div>
</template>

<script>
import RecentAction from './recent-action'

export default {
  components: { RecentAction },

  props: {
    backgroundColor: {
      type: String,
      required: true
    },
    getActionText: {
      type: Function,
      required: true
    },
    recentActions: {
      type: Array,
      required: true
    }
  },

  computed: {
    cssBackgroundColorForOverlay() {
      return {
        '--background-color': this.backgroundColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .recent-actions {
    position: relative;
    height: 60px;
    overflow-x: hidden;
  }

  // Our intended gradient for the overlay is from transparent to background color on the edges. However, there is some issue where fading
  // between transparent and white (a background color we use) has a gray color in between on some browsers: https://stackoverflow.com/a/11829561
  // We're using a workaround of having an almost-transparent color instead of transparent, which avoids this gray color in between.
  $almost-transparent: rgba(255,255,255,0.001);
  .overlay {
    width: 100%;
    position: absolute;
    height: 40px; // To not overlay a gradient on the scroll bar, make the overlay not span to where the scrollbar is.
    pointer-events: none;
    background: linear-gradient(to right, $almost-transparent calc(100% - 30px), var(--background-color) 100%);
  }
</style>
